import { CSSProperties, ReactNode } from 'react'

import Flexer from 'js/components/Flexer/Flexer'
import cx from 'js/lib/helpers/cx'

import styles from './ActionsBar.module.css'

export type ActionsBarProps = {
    show?: boolean
    hide?: boolean
    isColumn?: boolean
    isWidget?: boolean
    position?: 'top' | 'bottom'
    onFocus?: () => void
    onBlur?: () => void
    children: ReactNode
    className?: string
}

const ActionsBar = ({
    show,
    hide,
    isColumn, // Hover area is full width and always triggered (needed because widget actions area on top of column actions)
    isWidget, // Blue border color
    position = 'top',
    onFocus,
    onBlur,
    children,
}: ActionsBarProps) => {
    const hoverAreaOffset = isColumn ? '0' : '16px'

    const inlineStyle: CSSProperties & Record<string, string> = {
        '--hover-area-offset': hoverAreaOffset,
    }

    if (isWidget) {
        inlineStyle['--actions-bar-border-color'] =
            'var(--ref-palette-secondary-main)'
    }

    return (
        <div
            className={cx(styles.wrapper, 'ActionsBar')}
            data-position={position}
            data-show={show || undefined}
            data-hide={hide || undefined}
            data-is-widget={isWidget || undefined}
            data-is-column={isColumn || undefined}
            style={inlineStyle}
            onFocus={onFocus}
            onBlur={onBlur}
        >
            {/* Global class is targeted cross-module by StyledPageEditorRow to
            raise the first row's action bar above the sticky editor header */}
            <div className={cx(styles.actionsBarButtons, 'ActionsBarButtons')}>
                <Flexer
                    divider
                    dividerOffset="md"
                    gutter={false}
                    className={cx(
                        styles.actionsBarButtonsBg,
                        'ActionsBarButtonsBg',
                    )}
                >
                    {children}
                </Flexer>
            </div>
        </div>
    )
}

export default ActionsBar
